import React, { useEffect } from "react";
import { Message } from "rsuite";

export const ErrorSesion = () => {
  const IniciarSesion = () => {
    setTimeout(() => {
      window.location = `/#/App`;
    }, [5000]);
  };

  useEffect(() => {
    IniciarSesion();
  }, []);

  return (
    <div>
      <Message showIcon type="warning" header="Inicio de sesión">
        Debe iniciar sesión, no puede continuar en ningún módulo del sistema.
      </Message>
    </div>
  );
};
